import { render, staticRenderFns } from "./RouteCreate.vue?vue&type=template&id=0df447aa"
import script from "../../controllers/route/route-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/route/route-create.js?vue&type=script&lang=js&external"
import style0 from "./RouteCreate.vue?vue&type=style&index=0&id=0df447aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports